LoggedMealItemModel.$inject = ["$modelFactory", "$http", "$cacheFactory", "ApiHttp"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}import { toFloat } from "../../shared/helpers/to-float";

export var loggedMealItemDefaults = {
  id: 0,
  created_at: '',
  calories: '', // "33.00"
  proteins: '', // "2.40"
  carbohydrates: '', // "6.00"
  fats: '', // "0.60"
  portion: '', // "1.00"
  category: "",
  subcategory: "",
  unit: "",
  groceries_replacement_ratio: '', // "0.00"
  groceries_unit: "",
  unit_si: "",
  portion_si: '', // "180.00"
  exchanges: '', // "1.00"
  name: "",
  nutrition_info: "",
  logged_meal: 0, // 117029
  amount: "",
  amount_si: "" };


export var loggedMealItemModelMapObject = {
  portion: toFloat,
  calories: toFloat,
  proteins: toFloat,
  carbohydrates: toFloat,
  fats: toFloat,
  exchanges: toFloat,
  groceries_replacement_ratio: toFloat,
  portion_si: toFloat,
  amount: toFloat,
  amount_si: toFloat };


export function LoggedMealItemModel(
$modelFactory,
$http,
$cacheFactory,
ApiHttp)
{
  "ngInject";var

  LoggedMealItem = /*#__PURE__*/function (_$modelFactory) {_inherits(LoggedMealItem, _$modelFactory);function LoggedMealItem() {_classCallCheck(this, LoggedMealItem);return _possibleConstructorReturn(this, (LoggedMealItem.__proto__ || Object.getPrototypeOf(LoggedMealItem)).apply(this, arguments));}return LoggedMealItem;}($modelFactory(ApiHttp.loggedMealitems, {
    defaults: loggedMealItemDefaults,
    map: loggedMealItemModelMapObject,
    actions: {
      createMany: {
        method: 'POST',
        isArray: true } } }));




  LoggedMealItem.List.Model = LoggedMealItem;

  return LoggedMealItem;
}